/// <reference types="vite/types/importMeta" />
import { Axios } from 'axios-observable';
import { map } from 'rxjs';
import { PingResponse, PortalLoginResponse, RefreshTokenResponse } from '../../responses/intranet/auth.response';
import { SuccessSingleResponse } from '../../responses/base.response';
import { apiPathFn } from '@ntprsrf-frontend/common/src/utils/api';
import { AdminRolesListResponse } from '../../responses/intranet/admin.response';

const apiPath = apiPathFn(import.meta.env.VITE_AUTH_SERVICE);

export function logout() {
  return Axios.post<SuccessSingleResponse<null>>(apiPath(['logout']), undefined, {
    headers: {
      "Content-Type": "application/json"
    }
  })
    .pipe(
      map((response) => response.data)
    );
}

export function logoutEntraURL() {
  return apiPath(['entraid', 'logout']);
}

export function verifyToken() {
  return Axios.post<RefreshTokenResponse>(apiPath(['verify', 'token']), null)
    .pipe(
      map((response) => response.data)
    );
}

export function refreshToken() {
  return Axios.post<SuccessSingleResponse<null>>(apiPath(['refresh', 'portal-token']))
    .pipe(
      map((response) => response.data)
    );
}

export function ping() {
  return Axios.post<PingResponse>(apiPath(['ping']))
    .pipe(
      map((response) => response.data)
    );
}

export function ssoLogin(token: string) {
  return Axios.post<PortalLoginResponse>(apiPath(['sso', 'login']), {
    token
  })
    .pipe(
      map((response) => response.data)
    );
}

export function corppassLogin() {
  return apiPath(['corppass', 'login']);
}

export function corppassAuthorization(code: string, state: string) {
  return Axios.get<PortalLoginResponse>(apiPath(['corppass', 'authorization']), {
    params: {
      code,
      state
    }
  })
    .pipe(
      map((response) => response.data)
    );
}

/* intranet usage only */
export function entraLogin() {
  return apiPath(['entraid', 'login']);
}

interface EntraAuthRequest {
  code: string;
  state: string;
  error: string;
  errorDescription: string;
};

export function entraAuthorization(params: EntraAuthRequest) {
  return Axios.get<PortalLoginResponse>(apiPath(['entraid', 'authorization']), {
    params
  })
    .pipe(
      map((response) => response.data)
    );
}

export function adfsGenerateRequest() {
  return Axios.post<SuccessSingleResponse<string>>(apiPath(['adfs', 'newsamlrequest']))
    .pipe(
      map((response) => response.data)
    );
}

export function postRequestToURL(url: string, SAMLRequest: string) {
  const form = document.createElement('form');
  form.method = "post";
  form.action = url;
  const params = { SAMLRequest }
  const hiddenField = document.createElement('input');
  hiddenField.type = 'hidden';
  hiddenField.name = "SAMLRequest";
  hiddenField.value = params.SAMLRequest;
  form.appendChild(hiddenField);

  document.body.appendChild(form);
  form.submit();
}

export function rolesList() {
  return Axios.get<AdminRolesListResponse>(apiPath(["role", "list"]))
  .pipe(
    map((response) => response.data)
  );
}
